/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizationsettings_Role1Inputs */

const zh_organizationsettings_role1 = /** @type {(inputs: Organizationsettings_Role1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`角色`)
};

const en_organizationsettings_role1 = /** @type {(inputs: Organizationsettings_Role1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role`)
};

const es_organizationsettings_role1 = /** @type {(inputs: Organizationsettings_Role1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rol`)
};

/**
* | output |
* | --- |
* | "Role" |
*
* @param {Organizationsettings_Role1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const organizationsettings_role1 = /** @type {((inputs?: Organizationsettings_Role1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizationsettings_Role1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_organizationsettings_role1(inputs)
	if (locale === "en") return en_organizationsettings_role1(inputs)
	return es_organizationsettings_role1(inputs)
});
export { organizationsettings_role1 as "organizationSettings_role" }